// @flow
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import ActivityChart from './ActivityChart';
import ActivityGrid from './ActivityGrid';

import type { Activity_metrics } from './__generated__/Activity_metrics.graphql';

type Props = {
  metrics: Activity_metrics,
};

const styles = {
  container: {
    display: 'flex',
  },
};

const Activity = ({ metrics }: Props) => (
  <div style={styles.container}>
    <ActivityChart metrics={metrics} />
    <div style={{ padding: 10 }}>
      <ActivityGrid metrics={metrics} />
    </div>
  </div>
);

export default createFragmentContainer(Activity, {
  metrics: graphql`
    fragment Activity_metrics on Metrics {
      openJobOffers
      openJobRequestsWithNoOffers
      openJobRequests
      startedJobs
      pendingTutors
    }
  `,
});



// WEBPACK FOOTER //
// ./src/components/home/activity/Activity.js